export default {
  /*
   * Actualizar un medio de pago
   */
  update(id, data) {
    return Vue.http.put(`passenger/payment_medias/${id}`, {data}).then(
      response => response,
      response => Promise.reject(response.data.errors)
    )
  },
  /*
   * exists() comprueba si existen medios de pago de usuarios con los datos indicados
   */
  exists(params) {
    return Vue.http.get('passenger/payment_medias/check_existence', params).then(
      response => response.data.data
    )
  },
  canRecharge(params) {
    return Vue.http.get('passenger/payment_medias/check_payment_media_can_recharge', params).then(
      response => response,
      response => Promise.reject(response.data.errors)
    )
  },
  preRecharge(params) {
    return Vue.http.get('passenger/payment_medias/pre_recharge_request', params).then(
      response => response.data.data
    )
  }
}
